import { Component, AfterViewInit, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, App } from 'ionic-angular';
import { TableDirective } from '../../directives/table-directive';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { HttpErrorResponse } from '@angular/common/http';
import { TaxRate } from '../../app/models/TaxRate';
import { ModalDirective } from 'ngx-bootstrap';
import { NgForm } from '@angular/forms';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { AlertsHolder } from '../../app/models/AlertsHolder';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '../../../node_modules/@ionic/storage';

@Component({
  selector: 'page-taxrates',
  templateUrl: 'taxrates.html',
})
export class TaxRatesPage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(TableDirective)
  private table: TableDirective;

  @ViewChild('taxRateModal')
  private taxRateModal: ModalDirective;

  @ViewChild('deleteModal')
  private confirmModal: ModalDirective;

  @ViewChild('taxRateForm')
  private taxRateForm: NgForm;

  private pageName: string = 'page-taxrates';
  private taxrates: TaxRate[] = [];
  private currentTaxRate = new TaxRate();
  private navControllerService: NavControllerService;
  private alertsHolder: AlertsHolder;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private app: App,
    private backendService: PaytronBackendService,
    private translate: TranslateService,
    private storage: Storage
  ) {
    this.navControllerService = new NavControllerService(app, storage);
    this.alertsHolder = new AlertsHolder(translate);
  }

  ngOnInit(): void {
    this.table.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  ionViewDidEnter() {
    this.getTaxRates();
  }

  private getTaxRates() {
    this.backendService.getTaxRates().subscribe(
      (taxrates) => {
        this.taxrates = taxrates;
        this.table.refreshTable();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  addTaxRate() {
    this.currentTaxRate = new TaxRate();
    this.taxRateForm.resetForm();
    this.showTaxRateModal();
  }

  editTaxRate(taxrate: TaxRate) {
    this.currentTaxRate = taxrate;
    this.showTaxRateModal();
  }

  deleteTaxRate() {
    this.backendService
      .deleteTaxRate(this.currentTaxRate)
      .subscribe(
        (data) => {},
        (err: HttpErrorResponse) => {}
      )
      .add(() => {
        this.getTaxRates();
        this.closeConfirmModal();
      });
  }

  submitTaxRate(btnEvent: HTMLButtonElement) {
    btnEvent.disabled = true;
    this.backendService
      .saveOrUpdateTaxRate(this.currentTaxRate)
      .subscribe(
        (taxrate) => {
          this.closeTaxRateModal();
        },
        (err: HttpErrorResponse) => {
          let message;
          if (err.error.codeNumber == 'APP-011') {
            message = 'Input Error';
          } else {
            message = 'Error';
          }
          this.alertsHolder.show(message, 'danger');
        }
      )
      .add(() => {
        btnEvent.disabled = false;
        this.getTaxRates();
      });
  }

  onSearchChange(searchString) {
    this.table.filterBySearchText(searchString);
  }

  showTaxRateModal() {
    this.taxRateModal.show();
  }

  closeTaxRateModal() {
    this.taxRateModal.hide();
  }

  showConfirmModal(taxrate) {
    this.currentTaxRate = taxrate;
    this.confirmModal.show();
  }

  closeConfirmModal() {
    this.confirmModal.hide();
  }

  showUnitsOfMeasurePage() {
    this.navControllerService.showUnitsOfMeasurePage();
  }

  showCardTypesPage() {
    this.navControllerService.showCardTypesPage();
  }
}



// WEBPACK FOOTER //
// ./src/pages/taxrates/taxrates.ts